import { useSelector } from "react-redux";
import { CheckCircleIcon } from "@app/design-system/icons";
import { formatDateTime } from "@app/shared/utils/formatDate";
import { RootState } from "@app/store";
import styles from "./StopCompletedBadge.module.css";

export type StopCompletedBadgeProps = {
  /** Epoch ms the stop was completed. */
  completedAt: number;
};

/**
 * The checkmark + completion time shown next to a completed stop's title —
 * shared by Order Details' `StopRow` and Home's dropoff-tracking
 * `DropoffSection` so a completed stop renders identically on both pages.
 */
export const StopCompletedBadge = ({ completedAt }: StopCompletedBadgeProps) => {
  const language = useSelector((state: RootState) => state.setting.language);

  return (
    <span className={styles.completed}>
      <CheckCircleIcon size={14} color="var(--color-success)" />
      {formatDateTime(completedAt, language)}
    </span>
  );
};
